import { isProduction } from './environments';

/**
 * Local-only escape hatch to exercise the full proxy flow without super-admin.
 * Requires NEXT_PUBLIC_PROXY_DEV_BYPASS=true and a non-production NEXT_PUBLIC_ENV.
 */
export function isProxyDevBypassEnabled(): boolean {
  if (isProduction()) {
    return false;
  }

  return process.env.NEXT_PUBLIC_PROXY_DEV_BYPASS === 'true';
}
